import { Routes, Route } from 'react-router-dom';

import Home from '../containers/Home.js'
import Login from '../containers/Login.js';
import Signup from '../containers/Signup.js';
import SignupVerify from '../containers/SignupVerify.js';
import ClaimAccount from '../containers/ClaimAccount.js';
import ClaimAccountVerify from '../containers/ClaimAccountVerify.js';
import ForgotPassword from '../containers/ForgotPassword.js';
import ResetPassword from '../containers/ResetPassword.js';
import PrivacyPolicy from '../containers/PrivacyPolicy.js';
import Contact from '../containers/Contact.js';
import About from '../containers/About.js';
import Transaction from '../containers/Transaction';
import Historique from '../containers/Historique';
import Dashboard from '../containers/Dashboard';
// import NotFound from './NotFound';

export default function Routing() {

  return (
    <Routes>

      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/signup/verify" element={<SignupVerify />} />
      <Route path="/claim-account" element={<ClaimAccount />} />
      <Route path="/claim-account/verify" element={<ClaimAccountVerify />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/about" element={<About />} />
      <Route path="/transaction" element={<Transaction/>} />
      <Route path="/historique" element={<Historique/>} />
      <Route path="/dashboard" element={<Dashboard/>} />
      {/*<Route path="*" element={<NotFound />} /> */}

    </Routes>
  );
}
